import React, { Component } from "react";
import { connectStore } from "redux-box";
import { module as ui } from "@st/ui";
import { module as documentFile } from "@st/documentFile";
import { uploadFile } from "@s/api/file";

import {
  FormContainer,
  FormTitle,
  FormGroup,
  Label,
  Input,
  FileLabel,
  CheckboxLabel,
  SubmitButton,
  ErrorText
} from "./DocumentManagementForm.styled";

class DocumentManagementForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      description: "",
      frontend_url: "",
      password: "",
      s3_link: "",
      file_type: "",
      is_expired: false,
      isUploading: false,
    };
  }

  componentDidMount() {
    this.syncFormState();
  }

  componentDidUpdate(prevProps) {
    if (
        prevProps.documentFile.active_upload !== this.props.documentFile.active_upload ||
        prevProps.documentFile.is_edit_upload !== this.props.documentFile.is_edit_upload
    ) {
      this.syncFormState();
    }
  }

  syncFormState = () => {
    const { active_upload } = this.props.documentFile;
    this.setState({
      title: active_upload ? active_upload.title : "",
      description: active_upload ? active_upload.description || "" : "",
      frontend_url: active_upload ? active_upload.frontend_url : "",
      password: "",
      s3_link: active_upload ? active_upload.s3_link : "",
      file_type: active_upload ? active_upload.file_type || "" : "",
      is_expired: active_upload ? active_upload.is_expired : false,
      isUploading: false,
    });
  };

  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState({
      [name]: type === "checkbox" ? checked : value
    });
  };

  handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    this.setState({ isUploading: true });

    try {
      const res = await uploadFile(file);
      // res.file contains the URL from the response based on previous research
      console.log(res)
      const s3_link = res.file;
      const file_type = file.name.split('.').pop();

      this.setState({
        s3_link,
        file_type,
        isUploading: false,
      });

      this.props.documentFile.setDocumentFileError("");
    } catch (err) {
      console.error("File upload failed:", err);
      this.setState({ isUploading: false });
      this.props.documentFile.setDocumentFileError("File upload failed. Please try again.");
    }
  };

  validate = () => {
    const { title, frontend_url, password, s3_link } = this.state;
    const { is_edit_upload: isEdit } = this.props.documentFile;

    if (!title || title.length < 3) return "Title requires at least 3 characters.";
    if (!frontend_url || frontend_url.length < 3) return "Frontend URL requires at least 3 characters.";
    if (!s3_link || s3_link.length < 10) return "S3 Link (File) is required.";
    return null;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const validationError = this.validate();
    if (validationError) {
      this.props.documentFile.setDocumentFileError(validationError);
      return;
    }

    const { title, description, frontend_url, password, s3_link, file_type, is_expired } = this.state;
    const { is_edit_upload: isEdit, active_upload } = this.props.documentFile;

    let payload = {};

    if (isEdit && active_upload) {
      if (title !== active_upload.title) payload.title = title;
      if (description !== (active_upload.description || "")) payload.description = description;
      if (frontend_url !== active_upload.frontend_url) payload.frontend_url = frontend_url;
      if (s3_link !== active_upload.s3_link) payload.s3_link = s3_link;
      if (file_type !== (active_upload.file_type || "")) payload.file_type = file_type;
      if (is_expired !== active_upload.is_expired) payload.is_expired = is_expired;
      
      if (password) {
        payload.password = password;
      }
      

    } else {
      payload = {
        title,
        description,
        frontend_url,
        s3_link,
        file_type
      };
      if (password) {
          payload.password = password;
      }
    }

    if (isEdit && active_upload) {
      this.props.documentFile.updateDocumentFile({
        id: active_upload.id,
        payload,
      });
    } else {
      this.props.documentFile.createDocumentFile(payload);
    }
  };

  render() {
    const { is_edit_upload: isEdit, uploads_submitting: submitting, uploads_error: error } = this.props.documentFile;
    const { title, description, frontend_url, password, s3_link, file_type, is_expired, isUploading } = this.state;

    return (
      <FormContainer onSubmit={this.handleSubmit}>
        <FormTitle>{isEdit ? "Edit Document" : "New Document Record"}</FormTitle>

        <FormGroup>
          <Label>Title *</Label>
          <Input
            type="text"
            name="title"
            value={title}
            onChange={this.handleChange}
            placeholder="Enter title"
            required
          />
        </FormGroup>

        <FormGroup>
          <Label>Description</Label>
          <Input
            type="text"
            name="description"
            value={description}
            onChange={this.handleChange}
            placeholder="Optional description"
          />
        </FormGroup>

        <FormGroup>
          <Label>Frontend URL *</Label>
          <Input
            type="text"
            name="frontend_url"
            value={frontend_url}
            onChange={this.handleChange}
            placeholder="unique-identifier"
            required
          />
        </FormGroup>

        <FormGroup>
          <Label>Password <span style={{ fontWeight: 400, color: '#888', fontSize: '12px' }}>(optional — leave blank for no protection)</span></Label>
          <Input
            type="password"
            name="password"
            value={password}
            onChange={this.handleChange}
            placeholder="Leave blank to allow access without a password"
          />
        </FormGroup>

        <FormGroup>
          <Label>Document File *</Label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <FileLabel>
              {isUploading ? "Uploading..." : "Click to Upload File"}
              <input type="file" onChange={this.handleFileUpload} disabled={isUploading} />
            </FileLabel>
            {s3_link && !isUploading && (
              <span style={{ fontSize: '12px', color: '#389e0d' }}>
                <i className="fa fa-check-circle" /> File uploaded!
              </span>
            )}
          </div>
          <Input
            type="text"
            name="s3_link"
            value={s3_link}
            onChange={this.handleChange}
            placeholder="Uploaded file URL will appear here"
            required
            readOnly
          />
        </FormGroup>

        <FormGroup>
          <Label>File Type</Label>
          <Input
            type="text"
            name="file_type"
            value={file_type}
            onChange={this.handleChange}
            placeholder="Detected automatically"
            readOnly
          />
        </FormGroup>

        {isEdit && (
          <FormGroup>
            <CheckboxLabel>
              <input
                type="checkbox"
                name="is_expired"
                checked={is_expired}
                onChange={this.handleChange}
              />
              Is Expired
            </CheckboxLabel>
          </FormGroup>
        )}

        {error && <ErrorText>{error}</ErrorText>}

        <SubmitButton type="submit" disabled={submitting || isUploading}>
          {submitting ? "Saving..." : "Save"}
        </SubmitButton>
      </FormContainer>
    );
  }
}

export default connectStore({
  ui,
  documentFile,
})(DocumentManagementForm);
